<div class="row" *ngIf="isShowIdentifierBlock && (isfEntity.entityIdentifier || getValidationText(isfEntity, 'entityIdentifier'))">
  <div class="col-6 card-label">{{ "LABELS.ID_NUMBER" | translate }}</div>
  <div class="col-6">
    {{
      (isfEntity.entityIdentifierQualifier !== null
        ? ("IDENTIFIER_QUALIFIER." + isfEntity.entityIdentifierQualifier | translate) + " "
        : "") + (isfEntity.entityIdentifier | identifier)
    }}
    <div *ngIf="getValidationText(isfEntity, 'entityIdentifier')" class="text-error">
      {{ getValidationText(isfEntity, "entityIdentifier") | translate }}
    </div>
    <div *ngIf="getValidationText(isfEntity, 'entityIdentifierQualifier')" class="text-error">
      {{ getValidationText(isfEntity, "entityIdentifierQualifier") | translate }}
    </div>
  </div>
</div>
<div class="row" *ngIf="isfEntity.dateOfBirth || getValidationText(isfEntity, 'dateOfBirth')">
  <div class="col-6 card-label">{{ "FORM_LABEL.DATEOFBIRTH" | translate }}</div>
  <div class="col-6">
    <div *ngIf="isfEntity.dateOfBirth">
      {{ isfEntity.dateOfBirth | customDateByUtc }}
    </div>
    <div *ngIf="getValidationText(isfEntity, 'dateOfBirth')" class="text-error">
      {{ getValidationText(isfEntity, "dateOfBirth") | translate }}
    </div>
  </div>
</div>
<div class="row" *ngIf="isfEntity.name || getValidationText(isfEntity, 'name')">
  <div class="col-6 card-label">{{ "LABELS.NAME" | translate }}</div>
  <div class="col-6">
    {{ isfEntity.name }}
    <div *ngIf="getValidationText(isfEntity, 'name')" class="text-error">
      {{ getValidationText(isfEntity, "name") | translate }}
    </div>
  </div>
</div>

<div class="row" *ngIf="isfEntity.address || getValidationText(isfEntity, 'address')">
  <div class="col-6 card-label">{{ "LABELS.ADDRESS" | translate }}</div>
  <ng-container *ngIf="isValidIsfEntityAddress(); else invalidAddress">
    <div class="col-6" *ngIf="!getValidationText(isfEntity, 'address')">
      <address-details [address]="isfEntity.address"></address-details>
    </div>
    <div class="col-6 text-error" *ngIf="getValidationText(isfEntity, 'address') || getValidationText(isfEntity, 'state')">
      {{ getValidationText(isfEntity, "address") || getValidationText(isfEntity, "state") | translate }}
    </div>
  </ng-container>
  <ng-template #invalidAddress>
    <div *ngIf="isMissingIsfEntityAddressParts(); else malformedAdd" class="col-6 text-error">
      {{ "BACK_ERROR.MISSING_ADDRESS_PARTS" | translate }}
    </div>

    <ng-template #malformedAdd>
      <div class="col-6">
        <address-details [address]="isfEntity.address"></address-details>
        <div class="text-error">
          {{ "BACK_ERROR.ADDRESS_PARTS_MALFORMED" | translate }}
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
